import React from 'react'
import { Checkbox, GraniteDataGrid } from '@tecuity/granite-ui'

const UserRoleIdTable = ({property = {}, onChange, userRoleIds = [], userRoleProcessIds = [], optionsMap}) => {

  const filterArray = (array, value) => {
    return array.includes(value) ? array.filter(v => v !== value) : [...array, value]
  }

  const UpdateUserRoleIds = (id) => {
    onChange({
      UserRoleIds: filterArray(userRoleIds, id),
      UserRoleProcessIds: userRoleProcessIds
    })
  }

  const UpdateUserRoleProcessIds = (id) => {
    onChange({
      UserRoleIds: userRoleIds,
      UserRoleProcessIds: filterArray(userRoleProcessIds, id)
    })
  }

  const columns = [
    {
      field: 'Name',
      headerName: 'Role',
      disableColumnMenu: true,
      renderCell: (params) => <p style={{ fontWeight: 'bolder' }}>{params.row.Name}</p>,
    },
    {
      field: 'Category',
      flex: 1,
      headerName: 'Category',
      disableColumnMenu: true,
    },
    {
      field: 'View',
      key: '0',
      headerName: 'View',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
        <Checkbox
          title={`Can View - ${params.row.Name}`}
          ariaLabel={`Can View - ${params.row.Name}`}
          checked={userRoleIds.includes(params.row.RoleId)}
          onChange={
            () => UpdateUserRoleIds(params.row.RoleId)
          }
        />
      )},
    },
    {
      field: 'Process',
      headerName: 'Process',
      key: '1',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
        <Checkbox
          title={`Can Process - ${params.row.Name}`}
          ariaLabel={`Can Process - ${params.row.Name}`}
          checked={userRoleProcessIds.includes(params.row.RoleId)}
          onChange={
            () => UpdateUserRoleProcessIds(params.row.RoleId)
          }
        />
      )},
    },
  ]
  return (
    <div key={property.k} style={{ marginBottom: '40px' }}>
      <GraniteDataGrid
        rowsPerPageOptions={[10, 25, 50]}
        selectable={false}
        compressedView={true}
        columns={columns}
        rows={(optionsMap['userRoleOptions'] || []).map((item) => ({
          id: item.RoleId.toString(),
          ...item,
        }))}
        pageSize={10}
      />
    </div>
  )

}

export default UserRoleIdTable